import { render } from "./PrintHeaderDesign3.vue?vue&type=template&id=e4a7a278&scoped=true"
import script from "./PrintHeaderDesign3.vue?vue&type=script&lang=js"
export * from "./PrintHeaderDesign3.vue?vue&type=script&lang=js"

import "./PrintHeaderDesign3.vue?vue&type=style&index=0&id=e4a7a278&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a7a278"]])

export default __exports__